/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface APIKeyRevoke
 */
export interface APIKeyRevoke {
    /**
     *
     * @type {string}
     * @memberof APIKeyRevoke
     */
    keyId: string;
}

/**
 * Check if a given object implements the APIKeyRevoke interface.
 */
export function instanceOfAPIKeyRevoke(value: object): value is APIKeyRevoke {
    if (!('keyId' in value) || value['keyId'] === undefined) return false;
    return true;
}

export function APIKeyRevokeFromJSON(json: any): APIKeyRevoke {
    return APIKeyRevokeFromJSONTyped(json, false);
}

export function APIKeyRevokeFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIKeyRevoke {
    if (json == null) {
        return json;
    }
    return {

        'keyId': json['key_id'],
    };
}

  export function APIKeyRevokeToJSON(json: any): APIKeyRevoke {
      return APIKeyRevokeToJSONTyped(json, false);
  }

  export function APIKeyRevokeToJSONTyped(value?: APIKeyRevoke | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'key_id': value['keyId'],
    };
}
